<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import store from "@/store";
export default {
  name: "SaveObserver",
  meta: {
    description: "Componente común para títulos por secciones.",
    slots: {
      default: {
        type: "component",
        valid: []
      }
    }
  },
  inheritAttrs: true,
  props: {
    dirty:{
      type:Boolean,
      required:false, //Because ValidationObserver dirty is undefined in first render
       meta: {
        description: 'Establece validación al componente',
        example: 'true',
      }
    }
  },
  watch: {
    dirty: function(newValue) {
      store.commit("setFormDirty", {
        value: newValue,
        resetMethod: this.$parent.reset
      });
    }
  }
};
</script>
